import Vote from "./vote";

const debug = false
// const debug = "Notes"

export default class Votes {

    private _models: Vote[]

    constructor(models:Vote[]=[]) {
        this._models = models
    }

    get isEmpty():boolean {
        return _.isEmpty(this._models)
    }

    public toggleVote():void {
        if (this.hasAlreadyVoted) {
            this.unVote()
        } else {
            this.vote()
        }
    }

    get hasAlreadyVoted():boolean {
        return !!_.find(this._models, (vote)=>{
            return vote.userId === gd.user.id
        })
    }

    vote() {

        // make sure we don't add it twice
        if (this.hasAlreadyVoted) return false

        this._models.push(new Vote(gd.user.id, moment()))
    }

    unVote() {
        _.remove(this._models, (vote:Vote)=>{
            return vote.userId === gd.user.id
        })
    }

    get total():number {
        return this._models.length
    }

    get votes(){
        return this._models
    }

    // get groupedByType():GroupedData {
    //
    //     const result:GroupedData = _(this._models)
    //         .groupBy((model:Vote)=>{
    //             return model.type;
    //         })
    //         .toPairs()
    //         .map((group)=> {
    //
    //             const reactionType = Number(group[0])
    //
    //             return {
    //                 value       : reactionType,
    //                 sortValue   : reactionType,
    //                 label       : group[0],
    //                 items       : group[1]  // Reactions[]
    //             }
    //         })
    //         .orderBy((group)=>group.sortValue, SortDirection.ASC as any)
    //         .value() as GroupedData
    //
    //     return result
    // }

    static initFromJson(data:JSONArray) {
        const collection = new Votes([])

        _.map(data, (record:JSONObject)=>{
            collection.add(Vote.initFromJson(record))
        })

        return collection
    }


    add(vote: Vote) {
        this._models.push(vote)
    }

    toJSON():JSONArray {
        return _.map(this._models, (model:Vote)=>{
            return model.toJSON()
        })
    }

}
